module.exports = __webpack_public_path__ + "media/app/assets/hero-background-new-2c8cb97ab108f8b5cd8ae899ce2570cc.jpg";